export interface IndexFaqItem {
    title: string
    text: string
    index?: number
}

export const indexFaqItems: IndexFaqItem[] = [
    {
        title: 'Какие маркетплейсы поддерживает сервис?',
        text: 'Результаты появляются быстро, так как данные обновляются в реальном времени. Уже в первые дни вы получите полную картину по продажам и конкурентам. Многие пользователи замечают положительные изменения в течение первых недель.',
    },
    {
        title: 'Есть ли поддержка и обучение для новых пользователей?',
        text: 'Результаты появляются быстро, так как данные обновляются в реальном времени. Уже в первые дни вы получите полную картину по продажам и конкурентам. Многие пользователи замечают положительные изменения в течение первых недель.',
    },
    {
        title: 'Сервис подходит для малого бизнеса с небольшим количеством товаров?',
        text: 'Результаты появляются быстро, так как данные обновляются в реальном времени. Уже в первые дни вы получите полную картину по продажам и конкурентам. Многие пользователи замечают положительные изменения в течение первых недель.',
    },
    {
        title: 'Как сервис помогает улучшить видимость товаров на маркетплейсах?',
        text: 'Результаты появляются быстро, так как данные обновляются в реальном времени. Уже в первые дни вы получите полную картину по продажам и конкурентам. Многие пользователи замечают положительные изменения в течение первых недель.',
    },
    {
        title: 'Как быстро я увижу результаты после начала использования сервиса?',
        text: 'Результаты появляются быстро, так как данные обновляются в реальном времени. Уже в первые дни вы получите полную картину по продажам и конкурентам. Многие пользователи замечают положительные изменения в течение первых недель.',
    },
]
